import React, {Component} from "react";
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";
import Select from "../../../local_node_modules/react-select";
import {SmsProviders} from "../../../helper/enums";
import {request} from "../../../helper/APIUtils";
import {deepCopyObject, enumToSelectData, showAxiosError} from "../../../helper/helper";
import SweetAlert from "react-bootstrap-sweetalert";
import Alert from "react-s-alert";
import {isValidSmsProperty} from "../../../common/componentValidation";

class SmsProperty extends Component {
    constructor(props) {
        super(props);
        this.state = {
            smsProperty: null,
            alert: null
        }

        this.getCustomerSmsProperty = this.getCustomerSmsProperty.bind(this);
        this.onChangeSmsProperty = this.onChangeSmsProperty.bind(this);
        this.deleteCustomerSmsProperty = this.deleteCustomerSmsProperty.bind(this);
        this.saveCustomerSmsProperty = this.saveCustomerSmsProperty.bind(this);
    }

    componentDidMount() {
        this.getCustomerSmsProperty();
    }

    onChangeSmsProperty(e) {
        let smsProperty = deepCopyObject(this.state.smsProperty);
        smsProperty[e.target.name] = e.target.value;
        this.setState({smsProperty: smsProperty});
    }

    getCustomerSmsProperty() {
        let self = this;
        let params = {
            url: `/smsProperty/getCustomerSmsProperty`,
            method: "post",
            data: self.props.customer.recordId,
        };

        request(params)
            .then(function (response) {
                if (response.data) {
                    self.setState({smsProperty: response.data});
                } else {
                    self.setState({
                        smsProperty: {
                            recordId: null,
                            providerType: null,
                            username: "",
                            password: "",
                            header: ""
                        }
                    })
                }
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    deleteCustomerSmsProperty() {
        let self = this;
        let params = {
            url: `/smsProperty/deleteCustomerSmsProperty`,
            method: "post",
            data: self.state.smsProperty
        };

        request(params)
            .then(function (response) {
                self.setState({alert: null});
                self.getCustomerSmsProperty();
                Alert.success("SMS Bilgisi silme işlemi başarılı şekilde gerçekleşti.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
            }).catch(function (error) {
            Alert.error("Silme işlemi gerçekleştirilemedi!!!", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
            showAxiosError(error);
        });
    }

    saveCustomerSmsProperty() {
        let self = this;
        let smsProperty = deepCopyObject(self.state.smsProperty);
        if(smsProperty){
            if (smsProperty.customerId === null || smsProperty.customerId === undefined) {
                smsProperty.customerId = self.props.customer.recordId;
            }

            if (smsProperty.vknTckn === null || smsProperty.vknTckn === undefined) {
                smsProperty.vknTckn = self.props.customer.vknTckn;
            }
        }

        let result = isValidSmsProperty(smsProperty);

        let params = {
            url: `/smsProperty/saveCustomerSmsProperty`,
            method: "post",
            data: smsProperty
        };

        if (result.valid) {
            request(params)
                .then(function (response) {
                    self.getCustomerSmsProperty();
                    Alert.success("SMS Bilgileri başarılı şekilde kaydedildi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000
                    });
                }).catch(function (error) {
                showAxiosError(error);
            });
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
        }
    }

    render() {
        return (
            <Row className="FormRenk"
                 style={{marginLeft: '0px', paddingLeft: '0px', marginRight: "0px", paddingTop: '30px'}}>
                <Col sm="6">
                    <FormGroup row>
                        <Label sm={4}>Sağlayıcı: *</Label>
                        <Col sm={8}>
                            <Select
                                value={this.state.smsProperty && this.state.smsProperty.providerType}
                                clearable={false}
                                name="providerType"
                                placeholder="Seçiniz..."
                                onChange={(e) => this.onChangeSmsProperty({
                                    target: {
                                        name: "providerType",
                                        value: e.value
                                    }
                                })}
                                options={enumToSelectData(SmsProviders, true)}/>
                        </Col>
                    </FormGroup>
                </Col>
                <Col sm="6">
                    <FormGroup row>
                        <Label sm={4}>Kullanıcı Adı: *</Label>
                        <Col sm={8}>
                            <Input
                                type="text"
                                name="username"
                                value={this.state.smsProperty && this.state.smsProperty.username}
                                onChange={(e) => this.onChangeSmsProperty(e)}/>
                        </Col>
                    </FormGroup>
                </Col>

                <Col sm="6">
                    <FormGroup row>
                        <Label sm={4}>Şifre: *</Label>
                        <Col sm={8}>
                            <Input
                                type="text"
                                name="password"
                                value={this.state.smsProperty && this.state.smsProperty.password}
                                onChange={(e) => this.onChangeSmsProperty(e)}/>
                        </Col>
                    </FormGroup>
                </Col>

                <Col sm="6">
                    <FormGroup row>
                        <Label sm={4}>Header : *</Label>
                        <Col sm={8}>
                            <Input
                                type="text"
                                name="header"
                                value={this.state.smsProperty && this.state.smsProperty.header}
                                onChange={(e) => this.onChangeSmsProperty(e)}/>
                        </Col>
                    </FormGroup>
                </Col>

                <Col sm="6">
                    <FormGroup row className="col-sm-12">
                        <Button className="TekBtn kaydet pull-right"
                                style={{marginRight: "10%"}}
                                onClick={() => this.saveCustomerSmsProperty()}>
                            Kaydet
                        </Button>
                        <Button className="TekBtn delete bHizala"
                                disabled={this.state.smsProperty && this.state.smsProperty.recordId === null}
                                onClick={e => {
                                    this.setState({
                                        alert: (
                                            <SweetAlert showCancel warning
                                                        confirmBtnText="Evet"
                                                        cancelBtnText="Hayır"
                                                        confirmBtnBsStyle="danger"
                                                        cancelBtnBsStyle="default"
                                                        title="SMS bilgilerini silmek istediğize emin misiniz?"
                                                        onConfirm={() => {
                                                            this.deleteCustomerSmsProperty()
                                                        }}
                                                        onCancel={() => this.setState({alert: null})}>
                                                SMS bilgileri silinecek devam edilsin mi?
                                            </SweetAlert>)
                                    })
                                }}>
                            Sil
                        </Button>
                    </FormGroup>
                </Col>

                {this.state.alert &&
                <div className="row satirBasi">
                    {this.state.alert}
                </div>
                }

            </Row>
        )
    }
}

export default SmsProperty;